import fieldTranslate from '../resource/data/field-translate.json';

export default class FormUtil {
    static getFieldLabel = (str: string): string => {
        return (fieldTranslate as any)[str] ? (fieldTranslate as any)[str] : str;
    }
}